/**
 * FAQ Accordion Component
 * Handles accordion functionality for FAQ sections
 */

/**
 * Initialize accordion functionality
 */
function initAccordion() {
    // Add click handlers to all accordion buttons
    document.querySelectorAll('.accordion-button').forEach(button => {
        button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') === 'true' || false;
            const wrapper = button.closest('.accordion-wrapper');

            // If data-single-active is present, close all other panels first
            if (wrapper && wrapper.hasAttribute('data-single-active')) {
                wrapper.querySelectorAll('.accordion-button').forEach(otherButton => {
                    if (otherButton !== button && otherButton.getAttribute('aria-expanded') === 'true') {
                        // Close other panel
                        otherButton.setAttribute('aria-expanded', 'false');
                        const otherPanel = document.getElementById(otherButton.getAttribute('aria-controls'));
                        if (otherPanel) {
                            otherPanel.hidden = true;
                        }
                        otherButton.querySelector('.accordion-icon')?.classList.remove('active');
                    }
                });
            }

            // Toggle aria-expanded attribute
            button.setAttribute('aria-expanded', !expanded);

            // Toggle visibility of the accordion panel
            const panel = document.getElementById(button.getAttribute('aria-controls'));
            if (panel) {
                panel.hidden = expanded;
            }

            // Change the icon
            const icon = button.querySelector('.accordion-icon');
            if (icon) {
                if (expanded) {
                    icon.classList.remove('active');
                } else {
                    icon.classList.add('active');
                }
            }
        });
    });

    // Auto-open panel if wrapper has data-open-panel attribute
    const accordionWrapper = document.querySelector('.accordion-wrapper');

    if (accordionWrapper) {
        const openPanel = accordionWrapper.getAttribute('data-open-panel');

        if (openPanel !== null) {
            const buttons = document.querySelectorAll('.accordion-button');
            const buttonToClick = buttons[openPanel]; // Array indices start at 0

            if (buttonToClick) {
                buttonToClick.click();
            }
        }
    }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
} else {
    // DOM is already loaded
    initAccordion();
}

export { initAccordion };
